<div class="bg-[#491176] min-h-screen">
	<portals-navbar></portals-navbar>
	<div class="flex items-center justify-center min-h-screen pb-[76px]">
		<div class="text-center flex flex-col items-center">
			<h1 class="font-bold text-[#FBD354]" style="font-family: 'Roboto', sans-serif">Send us a video, audio or text message</h1>
			<div class="laptop:w-auto laptop:flex-1 mobile:w-full mobile_landscape:min-w-[370px] mobile_landscape:max-w-[370px] flex flex-col mobile_landscape:items-center" id="jottoWelcome">
				<div class="flex justify-center p-auto">
					<div class="w-full">
						<ng-container *ngIf="!ready" class="flex justify-center">
							<div class="flex items-center" [ngClass]="isMobile ? 'h-[100vh]' : 'min-h-[700px]'">
								<ngx-skeleton-loader
									appearance="custom-content"
									animation="progress-dark"
									[theme]="{
										height: isMobile ? '100vh' : '650px',
										width: isMobile ? '100%' : '370px',
										'border-radius': isMobile ? 'none' : '24px',
										'margin-bottom': '0px',
										background: 'var(--portals-theme-highlight)'
									}"
								></ngx-skeleton-loader>
							</div>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.WELCOME_SCREEN">
							<jotto-app-welcome [scrollable]="isMobile" (scrollContent)="scrollDiv()"></jotto-app-welcome>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.RESPONSE_SCREEN">
							<portals-notifications-response></portals-notifications-response>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.UPLOADING_SCREEN">
							<jotto-app-upload-notice></jotto-app-upload-notice>
						</ng-container>
						<ng-container *ngIf="responseService.currentPage?.screen === SCREENS.CHANNEL_FEED_SCREEN">
							<jotto-app-channel-feed [maxFeedHeight]="deviceService.isDesktop() ? '650px' : '700px'"></jotto-app-channel-feed>
						</ng-container>
					</div>
				</div>
			</div>

			<h2 class="text-white" style="font-family: 'Roboto', sans-serif; font-weight: 100">Please include your email in your message</h2>
		</div>
	</div>
</div>
